export enum TermsAndConditionsType {
  // General terms and conditions
  General = 1,
  // Loading card terms and conditions
  LoadCard = 2,
  // Print ticket terms and conditions
  PrintTicket = 3,
  // Ticket sell terms and conditions
  SellTickets = 4,
  // Ticket transfer terms and conditions
  TransferTickets = 5,
  // Pricacy policy
  PrivacyPolicy = 6,
  /// Loyalty terms and conditions
  LoyaltyScheme = 7,
  // Guardian specific terms and conditions
  Guardian = 8,
  // Child specific terms and conditions
  GuardianChildren = 9,
}
